import type * as React from "react";

import type { BadgeTone } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

/** C25 批1(P6):统计件——KPI 卡(mono 大写 label+彩点)与自绘横条,统一 r12 白卡(收编三种圆角)。 */

const DOT: Record<BadgeTone, string> = {
	success: "bg-brand-success",
	warning: "bg-brand-warning",
	danger: "bg-brand-danger",
	info: "bg-brand-info",
	accent: "bg-brand-accent",
	muted: "bg-text-muted",
	neutral: "bg-text-muted",
};

export function KpiCard({
	label,
	value,
	hint,
	tone = "neutral",
	className,
}: {
	label: React.ReactNode;
	value: React.ReactNode;
	hint?: React.ReactNode;
	tone?: BadgeTone;
	className?: string;
}) {
	return (
		<div className={cn("rounded-xl border border-surface-border bg-surface-card p-4", className)}>
			<div className="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-wide text-text-muted">
				<span className={cn("h-1.5 w-1.5 rounded-full", DOT[tone])} />
				{label}
			</div>
			<div className="pt-1 font-mono text-2xl font-semibold text-text-primary">{value}</div>
			{hint ? <div className="pt-0.5 text-xs text-text-muted">{hint}</div> : null}
		</div>
	);
}

/** 单色深浅横条(P6:量→深浅,不搬紫;弱底轨) */
export function MiniBar({
	value,
	max,
	tone = "accent",
	className,
}: {
	value: number;
	max: number;
	tone?: BadgeTone;
	className?: string;
}) {
	const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
	return (
		<div className={cn("h-2 w-full overflow-hidden rounded-full bg-surface-subtle", className)}>
			<div
				className={cn("h-full rounded-full transition-[width] duration-300", DOT[tone])}
				style={{ width: `${pct}%` }}
			/>
		</div>
	);
}
